import type { CompanySetting } from './company-setting.type.ts';

// These are technically all optional, but we should make a model
// that would give reasonable defaults.
export interface CompanySettingExtension extends CompanySetting {}
export class CompanySettingExtension {
  get employmentTypes() {
    return this.enums['EmploymentType'] || [];
  }

  get partnerUrlString() {
    const url = this.returnToPartnerUrl;
    return url ? `https://${url.subdomain}.${url.base}${url.path ? `/${url.path}` : ''}` : null;
  }
}

const Registration = {
  kind: 'object',
  name: 'company-setting',
  features: CompanySettingExtension,
};
export default Registration;
